<template>
    <div id="seasonCreator">
        <v-dialog v-model="addLeague" class="justify-center" width="600">
            <v-card class="justify-center">
                <v-card-title>
                    <v-row class="justify-center align-center pt-5">
                        <h2>Dodaj nową ligę</h2>
                    </v-row>
                </v-card-title>
                <v-card-actions class="justify-center">
                        <AddLeagueDialog class="pb-3" @changeDialogState="changeState"/>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-container class="mt-4">
            <v-row class="justify-center">
                <h1>Twój sezon</h1>
            </v-row>
            <v-row class="d-flex justify-content-end">
                <v-col cols="12" style="text-align:right">
                    <v-btn
                        color="#76EB6C"
                        dark
                        top
                        right
                        large
                        @click.stop="addLeague = !addLeague"
                    >
                        <v-icon left>mdi-plus</v-icon>
                        <span>Dodaj ligę</span>
                    </v-btn>
                </v-col>
            </v-row>
            <v-row class="d-flex justify-center">
                <v-col cols="12" sm="10">
                    <LeagueList />
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import AddLeagueDialog from '../../components/admin-components/AddLeague_admin'
import LeagueList from '../../components/admin-components/LeagueList_admin'
export default {
    components:{
        AddLeagueDialog,
        LeagueList
    },
    data(){
        return{
            addLeague:false,
        }
    },
    methods:{
        changeState(){
            this.addLeague=false;
        }
    }
}
</script>